import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  useLocation,
} from "react-router-dom";
import "./index.css";
import App from "./App.tsx";
import ErrorPage from "./Pages/ErrorPage.tsx";
// import FontTest from "./Pages/FontTest.tsx";
import Homepage from "./Pages/Homepage.tsx";
import NakshatraLanding from "./Pages/NakshatraLanding.tsx";
import AboutUs from "./Pages/AboutUs.tsx";
import Events from "./Pages/Events.tsx";
import Projects from "./Pages/Projects.tsx";
import Gallery from "./Pages/Gallery.tsx";
import ContactUs from "./Pages/ContactUs.tsx";
import EnquireNow from "./Pages/EnquireNow.tsx";
import LinkTree from "./Pages/LinkTree.tsx";
import ThankYou from "./Pages/ThankYou.tsx";
import { useEffect } from "react";

const RouterWrapper: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    // @ts-ignore
    window.dataLayer.push({
      event: "pageview",
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return <ErrorPage />;
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />} errorElement={<ErrorPage />}>
      <Route index element={<Homepage />} />
      {/* <Route path="/font" element={<FontTest />} /> */}
      <Route path="/about" element={<AboutUs />} />
      <Route path="/about/" element={<AboutUs />} />

      <Route path="/about-us" element={<AboutUs />} />

      <Route path="/chairman" element={<AboutUs />} />
      <Route path="/managing-director" element={<AboutUs />} />
      <Route path="/ceo" element={<AboutUs />} />

      <Route path="/chairman/" element={<AboutUs />} />
      <Route path="/managing-director/" element={<AboutUs />} />
      <Route path="/ceo/" element={<AboutUs />} />

      <Route path="/events" element={<Events />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/enquire" element={<EnquireNow />} />

      <Route path="/links" element={<LinkTree />} />
      <Route path="/thankyou" element={<ThankYou />} />

      <Route path="/nakshatra" element={<NakshatraLanding />} />
      <Route
        path="*"
        element={<RouterWrapper />}
        errorElement={<ErrorPage />}
      />
    </Route>,
  ),
);

createRoot(document.getElementById("root")!).render(
  <RouterProvider router={router} />,
);
